import { render, staticRenderFns } from "./CreateFollowupSkeleton.vue?vue&type=template&id=2fb30204&scoped=true"
import script from "./CreateFollowupSkeleton.vue?vue&type=script&lang=js"
export * from "./CreateFollowupSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CreateFollowupSkeleton.vue?vue&type=style&index=0&id=2fb30204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb30204",
  null
  
)

export default component.exports